module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-19.65f4183e.png";